import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {UtilidadesService } from '../../servicios/utilidades.service'

@Component({
  selector: 'app-dialog-mail-recuperar-pass',
  templateUrl: './dialog-mail-recuperar-pass.component.html',
  styleUrls: ['./dialog-mail-recuperar-pass.component.scss'],
})
export class DialogMailRecuperarPassComponent implements OnInit {
  fGroup: FormGroup;
  constructor(public dialogRef: MatDialogRef<DialogMailRecuperarPassComponent>, 
    @Inject(MAT_DIALOG_DATA)public message: string, private fb: FormBuilder, 
    private utilidades: UtilidadesService) { 
      this.fGroup = fb.group({
        Email: ['', [Validators.email]]
      })
     }

  ngOnInit() {}

  trimear(){
    setTimeout(() => {
      this.fGroup.patchValue({
        Email: String(this.fGroup.value.Email).trim()
      })
    }, 30);
  }

  onClickNo(info): void{
    if(info.Email!=''){
      if(this.fGroup.valid){
        this.dialogRef.close(info);
      }else{
        this.utilidades.MostrarMensaje({"Mensaje": "Ingresa un email valido", "Titulo": "", "Tipo": "mal"})
      }
    }else{
      this.dialogRef.close(info);
    }
  }

}
